<template>
    <div class="reporting">
        <div class="no-print">
<!-- HEADER -->
            <v-card-title>
                Report Generator
                <v-btn small dark color="grey" class="mr-4 ml-4 button-style" elevation="0" @click="$router.push('/account-view/' + id)">Back to Client</v-btn>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
                <small>Use this page to quickly generate client reports. Use 'Open PDF in preview' from print preview to download. <br> &#171; Make sure the side navigation is closed while printing...</small>
            </v-card-text>
            
            <v-card class="pa-8">
<!-- REPORT SETTINGS -->
            <v-form>
                <p class="form-label mt-3">Client</p>
                <v-row>
                    <v-col>          
                        <v-text-field v-model="clientData.company" @change="preview" outlined label="Client"></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field v-model="clientData.contactName" @change="preview" outlined label="Contact"></v-text-field>
                    </v-col>
                    <v-col>          
                        <v-text-field v-model="adminUser.email" @change="preview" outlined label="AM email"></v-text-field>
                    </v-col> 
                    <v-col>          
                        <v-select :items="tiers" v-model="clientData.tierType" @change="preview" outlined label="Tier"></v-select>
                    </v-col>
                    <v-col>
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field outlined v-model="date" label="Contract Received..." prepend-icon="event" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" @input="menu2 = false" @change="changeDate"></v-date-picker>
                        </v-menu>
                    </v-col>   
                </v-row>
<!-- USAGE STATS -->
                <p class="form-label mt-3">Usage stats</p>
                <v-row>
                    <v-col>
                        <v-text-field label="Users" @input="preview" v-model="statsData.users" type="number" outlined></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="Active" @input="preview" v-model="statsData.active" type="number" outlined></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="Logins" @input="preview" v-model="statsData.logins" type="number" outlined></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="Upgrades" :disabled="clientData.tierType == 'Enterprise'" @input="preview" v-model="statsData.upgrades" type="number" outlined></v-text-field>
                    </v-col>    
<!-- NPS -->
                    <v-col>
                        <v-text-field label="Promoters" name="Promoters" @input="npsCalc" v-model="statsData.promoters" type="number" outlined></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="Neutral" name="Neutral" @input="npsCalc" v-model="statsData.neutral" type="number" outlined></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="Detractors" name="Detractors" @input="npsCalc" v-model="statsData.detractors" type="number" outlined></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="nps" name="nps" v-model="statsData.nps" type="number" disabled outlined></v-text-field>
                    </v-col>
                </v-row>
<!-- QUESTIONS -->
                <p class="form-label mt-3">Questions</p>
                <v-row>
                    <v-col>
                        <v-text-field outlined name="Question1" label="Question 1" @input="preview" v-model="questions.one.title" type="text"></v-text-field>
                        <v-text-field outlined @input="preview" :label="questions.one.param1.label" name="Yes1" v-model="questions.one.param1.value" type="number"></v-text-field>
                        <v-text-field outlined @input="preview" :label="questions.one.param2.label" name="No1" v-model="questions.one.param2.value" type="number"></v-text-field>
                        <v-text-field outlined @input="preview" :label="questions.one.param3.label" name="NotSure1" v-model="questions.one.param3.value" type="number"></v-text-field>
                    </v-col>



                    <v-col>
                        <v-row>
                            <v-col>
                                <v-text-field outlined name="Question2" label="Question 2" v-model="questions.two.title" type="text"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="ma-0 pa-0">
                            <v-col class="py-0">
                                <v-text-field outlined @input="preview" label="Label" v-model="questions.two.param1.label" type="text"></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field outlined @input="preview" label="Value" v-model="questions.two.param1.value" type="number"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="ma-0 pa-0">
                            <v-col class="py-0">
                                <v-text-field outlined @input="preview" label="Label" v-model="questions.two.param2.label" type="text"></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field outlined @input="preview" label="Value" v-model="questions.two.param2.value" type="number"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="ma-0 pa-0">
                            <v-col class="py-0">
                                <v-text-field outlined @input="preview" label="Label" v-model="questions.two.param3.label" type="text"></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field outlined @input="preview" label="Value" v-model="questions.two.param3.value" type="number"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="ma-0 pa-0">
                            <v-col class="py-0">
                                <v-text-field outlined @input="preview" label="Label" v-model="questions.two.param4.label" type="text"></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field outlined @input="preview" label="Value" v-model="questions.two.param4.value" type="number"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="ma-0 pa-0">
                            <v-col class="py-0">
                                <v-text-field outlined @input="preview" label="Label" v-model="questions.two.param5.label" type="text"></v-text-field>
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field outlined @input="preview" label="Value" v-model="questions.two.param5.value" type="number"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>



                    <v-col>
                        <v-text-field outlined disabled name="Question3" label="Question 3" v-model="questions.three.title" type="text"></v-text-field>
                        <v-text-field outlined disabled @input="preview" :label="questions.three.param1.label" name="Yes3" v-model="questions.three.param1.value" type="number"></v-text-field>
                        <v-text-field outlined disabled @input="preview" :label="questions.three.param2.label" name="No3" v-model="questions.three.param2.value" type="number"></v-text-field>
                    </v-col>
                </v-row>
<!-- NOTES -->
                <p class="form-label mt-3">Notes</p>
                <v-row>
                    <v-col x12 sm12>
                        <v-input outlined style="text-align: left; max-width: 100%;">
                            <vue-editor @change="preview" v-model="notes" :editorToolbar="customToolbar"></vue-editor>
                        </v-input>
                    </v-col>
                </v-row>
<!-- COMMENTS FROM RENTERS -->
                <p class="form-label mt-3">Comments from renters</p>
                <v-row>
                    <v-col>
                        <v-input>
                            <v-textarea outlined id="notes-input" @input="csvParse" type="textarea" v-model="csvString" name="input-7-1" label="Copy and paste from spreadsheet - Maximum of 20 rows" auto-grow value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."></v-textarea>
                        </v-input>
                    </v-col>
                </v-row>

                <!-- <p class="form-label">Comments from renters extended</p>
                <v-row>
                    <v-col>
                        <v-input>
                            <v-textarea outlined id="notes-input" @input="csvParse2" type="textarea" v-model="csvString2" name="input-7-1" label="Copy and paste from spreadsheet - Maximum of 20 rows" auto-grow value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."></v-textarea>
                        </v-input>
                    </v-col>
                </v-row> -->
<!-- LOGO URL -->
                <p class="form-label mt-3">Logo URL</p>
                <v-row>
                    <v-col x12 sm12>
                        <v-text-field outlined @input="preview" v-model="brandData.logoUrl" name="Logo Url" type="text" label="Logo Url"></v-text-field>
                    </v-col>
                </v-row>
<!-- CUSTOM COLOURS -->
                <p class="form-label mt-3">Colours</p>
                <v-row>
                    <v-col cols="4" md="2">
                        <div class="color-pickers">
                            <p class="color-picker-text">Header</p>
                            <v-input>
                                <chrome-picker @input="preview" v-model="brandData.primaryColour" />
                            </v-input>
                        </div>
                    </v-col>
                    <v-col cols="4" md="2">
                        <div class="color-pickers">
                            <p class="color-picker-text">Title</p>
                            <v-input>
                                <chrome-picker @input="preview" v-model="brandData.secondaryColour" />
                            </v-input>
                        </div>
                    </v-col>
                    <v-col cols="4" md="2">
                        <div class="color-pickers">
                            <p class="color-picker-text">Button</p>
                            <v-input>
                                <chrome-picker @input="preview" v-model="brandData.buttonColour" />
                            </v-input>
                        </div>
                    </v-col>
                    <v-col cols="4" md="2">
                        <div class="color-pickers">
                            <p class="color-picker-text">Button-text</p>
                            <v-input>
                                <chrome-picker @input="preview" v-model="brandData.buttonTextColour" />
                            </v-input>
                        </div>
                    </v-col>
                    <v-col cols="4" md="2">
                        <div class="color-pickers">
                            <p class="color-picker-text">Foreground</p>
                            <v-input>
                                <chrome-picker @input="preview" v-model="brandData.foregroundColour" />
                            </v-input>
                        </div>
                    </v-col>
                    <v-col cols="4" md="2">
                        <div class="color-pickers">
                            <p class="color-picker-text">Background</p>
                            <v-input>
                                <chrome-picker @input="preview" v-model="brandData.backgroundColour" />
                            </v-input>
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="3">
                        <v-btn @click="print" elevation="0" dark block color="green" class="button-style">
                            Print
                        </v-btn>
                    </v-col>
                    <!-- <v-col cols="3">
                        <v-btn elevation="0" dark block color="blue" class="button-style">
                            Save
                        </v-btn>
                    </v-col> -->
                </v-row>
            </v-form>
            </v-card>
        </div>

<!-- PREVIEW FOR PRINT -->
        <div class="preview">
            <div :style="headerstyled" class="preview-header">
                <p>
                    <span>
                        <img :src="brandData.logoUrl" style="height: 40px;">
                    </span>
                    <span class="is-pulled-right header-text">
                        Usage report for <strong>{{ this.clientData.company }}</strong> {{ cleanDate }}
                    </span>
                </p>
            </div>
            <div class="stats-container">
                <div class="stats" :style="commentstyled">
                    Users: <strong>{{ statsData.users }}</strong>
                </div>
                <div class="stats" :style="commentstyled">
                    Active: <strong>{{ statsData.activationRate }}%</strong>
                </div>
                <div class="stats" :style="commentstyled">
                    Logins: <strong>{{ statsData.logins }}</strong>
                </div>
                <div class="stats" :style="commentstyled">
                    NPS: <strong>{{ statsData.nps }}</strong>
                </div>
            </div>     
            <div class="main-text">
                <div class="notes" v-html="notes">
                {{ notes }}
                </div>
            </div>
            <div class="nps-text">
                Net Promoter Score: <strong>{{ statsData.nps }}</strong>. Above zero is positive, above 20 is worth bragging about. 
            </div>
            <div class="nps-bar">
                <div class="nps-indicator"> {{ statsData.nps }} </div>
                <div class="nps-bad">-100</div>
                <div class="nps-ok">0</div>
                <div class="nps-good">+100</div>
            </div>
            <charts ref="charts" :D1="chart1" :D2="chart2" :D3="chart3" :Q="question" :Q2Labels="questions.two" :bind="false" :H="brandData.backgroundColour.hex" :T="brandData.foregroundColour.hex"></charts>
            <div class="comments" :style="commentstyled">
                <h3>
                    Comments from renters
                </h3>
                <br>
                <div class="comments-half">
                    <p v-for="(comment, index) in comments" :key="index" ><span v-if="comment[0].length > 0">• &nbsp; {{ comment[0] }}</span></p>
                </div>
            </div>
            <div style="background-color: #ffffff; color: #52296F;" class="preview-footer">
                <p><span><img src="https://storage.googleapis.com/instapage-user-media/00e44294/37029051-0-Vaboo-Logo-Purple-SV.svg" style="height: 35px;"></span><span class="is-pulled-left footer-text">Created on <strong>{{ this.cleanDate }}</strong> for {{ clientData.contactName }} by <a :href="accountManagerEmail" target="BLANK">{{ adminUser.email }}</a></span></p>
            </div>
        </div>


<!-- PREVIEW FOR PRINT PAGE 2 -->
        <!-- <div class="preview-2">
            <div :style="headerstyled" class="preview-header">
                <p>
                    <span>
                        <img :src="brandData.logoUrl" style="height: 40px;">
                    </span>
                    <span class="is-pulled-right header-text">
                        Usage report for <strong>{{ this.clientData.company }}</strong> {{ cleanDate }}
                    </span>
                </p>
            </div>
            <div class="comments2" :style="commentstyled">
                <h3>
                    More comments from renters
                </h3>
                <br>
                <div class="comments-half2">
                    <p v-for="(comment, index) in comments2" :key="index" ><span v-if="comment[0].length > 0">• &nbsp; {{ comment[0] }}</span></p>
                </div>
            </div>
            <div style="background-color: #ffffff; color: #52296F;" class="preview-footer">
                <p><span><img src="https://storage.googleapis.com/instapage-user-media/00e44294/37029051-0-Vaboo-Logo-Purple-SV.svg" style="height: 35px;"></span><span class="is-pulled-left footer-text">Created on <strong>{{ this.cleanDate }}</strong> for {{ clientData.contactName }} by <a :href="accountManagerEmail" target="BLANK">{{ adminUser.email }}</a></span></p>
            </div>
        </div> -->

    </div>
</template>
<script>
import Vue from 'vue'
import db from '../firebase/init.js'
import { Chrome } from 'vue-color'
import { VueEditor } from 'vue2-editor'
import moment from 'moment'
import Papa from 'papaparse'
import Charts from './Charts.vue'
export default {
    name: 'Report',
    components: {
        'chrome-picker': Chrome,
        VueEditor,
        Charts
    },
    data(){
        return {
    // report data
            id: this.$route.params.id,
            report: this.$route.params.time,
            adminUser: this.$store.getters.currentAdminUser,
            brandSet: false,
            brandData: { logoUrl: '', primaryColour: '#52296F', secondaryColour: '#ffffff', buttonColour: '#52296F', buttonTextColour: '#ffffff', backgroundColour: '#52296F', foregroundColour: '#BDA3CF' },
            clientData: { company: '', contactName: '', tierType: '' },
            statsData: { activationRate: 0, users: 0, active: 0, upgrades: 0, logins: 0, promoters: 0, neutral: 0, detractors: 0, nps: 0, time: 0 },
            date: new Date().toISOString().substr(0, 10),
            cleanDate: moment(this.date).format('ll'),
            tiers: ['Essential', 'Branded', 'Enterprise'],
    // Question data
            questions: {
                one: {
                    type: 'Pie',
                    title: 'Worried about the cost of living',
                    param1: { label: 'Said yes', value: 20 },
                    param2: { label: 'Said no', value: 30 },
                    param3: { label: 'Said not sure', value: 30 }
                },
                two: {
                    type: 'Bar',
                    title: 'Most helpful savings',
                    param1: { label: 'Household bills', value: 10 },
                    param2: { label: 'Groceries', value: 30 },
                    param3: { label: 'Travel', value: 3 },
                    param4: { label: 'Social life', value: 21 },
                    param5: { label: 'Health & fitness', value: 8 }
                },
                three: {
                    type: 'Pie',
                    title: 'Activation rate to date',
                    param1: { label: 'Active', value: 0 },
                    param2: { label: 'Inactive', value: 0 }
                },
            },
    // chart data
            chart1: [{
                    data: [],
                    backgroundColor: [],
                    hoverBackgroundColor: []
                }],
            chart2: [{
                    data: [],
                    backgroundColor: [],
                    hoverBackgroundColor: []
                }],
            chart3: [{
                    data: [],
                    backgroundColor: [],
                    hoverBackgroundColor: []
                }],
    // brand / content info 
            headerstyled: {},
            commentstyled: {},
            accountManagerEmail: '',
            comments: [],
            comments2: [],
            csvString: '',
            csvString2: '',
            // notes: "<p>Hi FIRSTNAME, </p><p>AGENT NAME customers are very happy with their experience and are logging into their perks platform regularly. The activation rate is lower than average - So we’re scheduling in an activation push next week.</p><p>We also suggest communicating your service to your customers more often. If you'd like to chat about the best ways to do this, feel free to let us know and we'll work together to improve this.</p><p>Keep in mind, adding users in the week they become a customer will also improve the activation rate.</p>",
            notes: '<p>Hi FIRSTNAME,</p><p>COMPANY customers are very happy with their experience and are logging into their perks platform regularly. As always, it\'s a priority for us to increase activations and we\'re increasing this each month.</p><p>To increase general usage of the platform, we\'ve created some useful examples of how you can communicate this element of your service to your customers - it would be great to have a chat about these.</p><p>Adding users in the week they become a customer is important, we should also discuss how we can help with this.</p>',
    // config info
            customToolbar: [
                ['bold', 'italic', 'underline'],['clean'],
            ],
            config: {
                quotes: false,
                quoteChar: '"',
                escapeChar: '"',
                delimiter: "/t",
                header: false,
                dynamicTyping: true,
                complete: function(data) {
                    this.comments = data.data
                }
            },
            menu: false,
            modal: false,
            menu2: false
        }
    },
    computed: {
        question() {
            let object = {
                one: this.questions.one.title,
                two: this.questions.two.title,
                three: this.questions.three.title
            }
            return object
        }
    },
    methods: {
        showNotes(){
            console.log(this.notes)
        },
        getClient(){
            firebase.firestore().collection('clients').doc(this.id).get().then(doc => { this.clientData = doc.data() }, err => { console.log(`Encountered error: ${err}`) })
            firebase.firestore().collection('clients').doc(this.id).collection('branding').doc('reporting').get().then(doc => { this.brandData = doc.data() }, err => { console.log(`Encountered error: ${err}`) }).then(() => { this.preview() })
            firebase.firestore().collection('clients').doc(this.id).collection('stats').doc(this.report).get().then(doc => { this.statsData = doc.data() }, err => { console.log(`Encountered error: ${err}`) }).then(() => { this.preview() })
        },
        changeDate(){
            this.cleanDate = moment(this.date).format('DD/MM/YYYY') 
        },
        preview(){
            this.questions.three.param1.value = this.statsData.active
            this.questions.three.param2.value = this.statsData.users - this.statsData.active
            this.headerstyled = { backgroundColor: this.brandData.primaryColour.hex, color: this.brandData.secondaryColour.hex }
            this.logoUrl = this.brandData.logoUrl
            this.commentText = this.invertColor(this.brandData.buttonColour.hex, true)
            this.commentstyled = { backgroundColor: this.brandData.buttonColour.hex, color: this.commentText }
            this.accountManagerEmail = "mailto:" + this.adminUser.email
            this.statsData.activationRate = Number((this.statsData.active / this.statsData.users) * 100).toFixed(2)
            this.chart1[0].data = [this.questions.one.param1.value, this.questions.one.param2.value, this.questions.one.param3.value]
            this.chart1[0].backgroundColor = [ this.brandData.buttonColour.hex,this.brandData.backgroundColour.hex, this.brandData.foregroundColour.hex]
            this.chart1[0].hoverBackgroundColor = [ this.brandData.buttonColour.hex,this.brandData.backgroundColour.hex, this.brandData.foregroundColour.hex]
            this.chart2[0].data = [this.questions.two.param1.value, this.questions.two.param2.value, this.questions.two.param3.value, this.questions.two.param4.value, this.questions.two.param5.value]
            this.chart2[0].backgroundColor = [this.brandData.backgroundColour.hex, this.brandData.foregroundColour.hex, this.brandData.backgroundColour.hex, this.brandData.foregroundColour.hex, this.brandData.backgroundColour.hex]
            this.chart2[0].hoverBackgroundColor = [this.brandData.backgroundColour.hex, this.brandData.foregroundColour.hex]
            this.questions.three.param1.value = Number(this.statsData.active)
            this.questions.three.param2.value = Number(this.statsData.users - this.statsData.active)
            this.chart3[0].data = [this.questions.three.param1.value, this.questions.three.param2.value]
            this.chart3[0].backgroundColor = [this.brandData.backgroundColour.hex, this.brandData.foregroundColour.hex]
            this.chart3[0].hoverBackgroundColor = [this.brandData.backgroundColour.hex, this.brandData.foregroundColour.hex]
            this.changeDate()
            this.npsCalc()
            document.title = "Vaboo_Report__" + this.clientData.company + "_" + this.cleanDate
        },     
        npsCalc(){
            let total = Number(this.statsData.detractors) + Number(this.statsData.neutral) + Number(this.statsData.promoters)
            let pp = (this.statsData.promoters / total) * 100
            let dp = (this.statsData.detractors / total) * 100
            this.statsData.nps = Math.floor(Number(pp - dp))
            let mrg = (Number(this.statsData.nps) + 92)
            $('.nps-indicator').css('left', mrg + 'mm')
        },
        csvParse(){
            this.comments = Papa.parse(this.csvString, this.config)
            this.comments = { ...this.comments.data }
            this.comments = { ...this.comments }
        },
        csvParse2(){
            this.comments2 = Papa.parse(this.csvString2, this.config)
            this.comments2 = { ...this.comments2.data }
            this.comments2 = { ...this.comments2 }
        },
        invertColor(hex, bw) {
            if (hex.indexOf('#') === 0) {
                hex = hex.slice(1);
            }
            if (hex.length === 3) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            if (hex.length !== 6) {
                throw new Error('Invalid HEX color.');
            }
            var r = parseInt(hex.slice(0, 2), 16),
                g = parseInt(hex.slice(2, 4), 16),
                b = parseInt(hex.slice(4, 6), 16);
            if (bw) {
                return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                    ? '#000000'
                    : '#FFFFFF';
            }
            r = (255 - r).toString(16);
            g = (255 - g).toString(16);
            b = (255 - b).toString(16);
            return "#" + padZero(r) + padZero(g) + padZero(b);
        },
        print(){
            window.print(1)
        },
    },
    created (){
        this.getClient()
    },
    mounted(){
    }
}
</script>
<style>
.reporting{
    position: relative;
}
.header{
    background-color: #424242;
    color: #ffffff;
    text-align: left;
    margin-bottom: 15px;
    padding-bottom: 5px;
}
.page-title{
    font-size: 26px;
    margin-top: 25px;
}
@media print
{    
    .no-print, .no-print *
    {
        display: none !important;
    }
    .preview, .preview * {
        visibility: visible;
    }
    .preview-2, .preview-2 * {
        visibility: visible;
    }
}
.form-label{
    font-size: 20px;
    margin-top: -30px;
    text-align: left;
}
.field{
    margin: 15px;
}
#input__label__hex__106{
    display: none;
}
.vc-chrome-toggle-btn{
    display: none;
}
.vc-input__input{
    color: #424242 !important;
}
.vc-chrome{
    box-shadow: 0 0 0px rgba(255, 255, 255, 0), 0 0px 0px rgba(255, 255, 255, 0) !important;
    border-radius: 15px !important;
}
.label-group{
    font-size: 20px;
    line-height: 0;
    text-align: left;
    margin: 10px 15px 0px 15px;
}
strong{
    color: inherit;
    -webkit-print-color-adjust:exact;
}
.quillWrapper{
    width: 100%;
}
.ql-editor{
    background-color: #ffffff;
}
.color-pickers{
    margin-top: 20px;
}
.color-picker-text{
    margin-bottom: 0px;
    text-align: left;
    font-weight: 300;
}
.preview{
    -webkit-print-color-adjust: exact;
    margin: 0;
    height: 297mm;
    width: 210mm;
    margin-top: -76px;
    visibility: hidden;
    margin-left: -12px;
    position: absolute;
    top: 0;
}
.preview-2{
    margin: 0;
    height: 297mm;
    width: 210mm;
    margin-top: calc(303.99mm - 76px);
    visibility: hidden;
    margin-left: -12px;
    position: absolute;
    top: 0;
}
.preview-header{
    padding: 20px;
    margin: 0;
    height: 75px;
    width: 100%;
    top: 0;
    -webkit-print-color-adjust:exact;
    box-shadow: 0 0 2px rgba(71, 71, 71, 0.1), 0 2px 8px rgba(28, 28, 28, 0.1) !important;
}
.header-text{
    margin-top: 10px;
    text-align: right;
    font-size: 14px;
    right: 25px;
    position: absolute;
    -webkit-print-color-adjust:exact;
}
.stats-container{
    box-shadow: 0 0 2px rgba(71, 71, 71, 0.1), 0 2px 8px rgba(28, 28, 28, 0.1) !important;
    width: 100%;
    height: 50px;
}
.stats{
    width: 25%;
    height: 50px;
    float: left;
    padding: 15px;
    text-align: center;
}
.main-text{
    padding: 20px 40px;
    margin-top: 10px;
    text-align: left;
    float: left;
    font-size: 14px;
    color: #424242;
}
.nps-text{
    padding: 0px 40px;
    text-align: left;
    float: left;
    font-size: 14px;
    margin-top: -20px;
    color: #424242;
}
.nps-bar{
    width: 90%;
    height: 20px;
    float: left;
    margin-left: 5%;
    margin-right: 5%;
    margin-top: 35px;
    color: #ffffff;
}
.nps-indicator{
    width: 40px;
    position: absolute;
    transform: translateY(-6px);
    color: black;
    padding: 6px;
    text-align: center;
    border-radius: 30px;
    background-color: #ffffff;
    transition: 2s ease;
    margin-left: 5mm;
}
.nps-bad{
    width: 25%;
    height: 25px;
    background-color: rgb(199, 34, 34);
    border-right: 2px solid white;
    border-radius: 5px 0px 0px 5px;
    float: left;
    text-align: left;
    padding: 2px 8px;
}
.nps-ok{
    width: 50%;
    height: 25px;
    background-color: rgb(237, 208, 95);
    border-right: 2px solid white;
    float: left;
    text-align: center;
        padding: 2px 8px;
}
.nps-good{
    width: 25%;
    height: 25px;
    background-color: rgb(38, 138, 38);
    border-radius: 0px 5px 5px 0px;
    float: left;
    text-align: right;
    padding: 2px 8px;
}
.comments{
    text-align: left;
    padding: 35px;
    margin: 0px;
    -webkit-print-color-adjust:exact;
    position: absolute;
    bottom: 0;
    margin-bottom: 75px;
    width: 100%;
}
.comments2{
    text-align: left;
    padding: 35px 35px 90px 35px;
    margin: 0px;
    -webkit-print-color-adjust:exact;
    position: absolute;
    top: 75px;
    width: 100%;
    height: 258mm;
    z-index: 300;
}
.comments p{
    margin-bottom: 0;
}
.comments2 p{
    margin-bottom: 0;
}
.comments-half{
    width: 100%;
    column-count: 2;
    font-size: 12px;
    margin-bottom: 20px;
}
.comments-half2{
    width: 100%;
    column-count: 2;
    font-size: 12px;
    -webkit-column-count: 2;
}
.preview-footer{
    padding: 30px;
    margin: 0px;
    height: 100px;
    width: 100%;
    -webkit-print-color-adjust:exact;
    position:absolute;
    bottom: 0px;
}
.footer-text{
    font-size: 12px;
    margin: 1px;
    position: absolute;
    right: 20px;
    padding: 10px;
    -webkit-print-color-adjust:exact;
}
.footer-text a {
    color: inherit;
}
</style>